@if (randomHints.length>0) {
  <div class="container">
    @for (hint of randomHints; track hint) {
      <div class="hint" (click)="hintSelected.emit(hint)">
        <div class="icon">
          <mat-icon>lightbulb_outline</mat-icon>
        </div>
        <span>
          {{ hint }}
        </span>
      </div>
    }
  </div>
}

